import { getPriceCards } from './getPriceCards'
import { renovateCard } from './renovateCard'

export default {
  getPrices: getPriceCards,
  renovate: renovateCard
}
